import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import {
  appointmentRecurrenceSelector,
  pastEhrAppointmentsSelector,
} from '@screens/NutritionistHub/models/nutritionistHub.selectors.ts'
import { userSelector } from '@selectors/app.ts'
import { EhrAppointmentStateKind } from '@src/types.ts'

export const useRecurrenceCallProgressCard = () => {
  const dispatch = useDispatch()

  const appointmentRecurrence = useSelector(appointmentRecurrenceSelector)
  const pastEhrAppointments = useSelector(pastEhrAppointmentsSelector)

  const user = useSelector(userSelector)
  const userIsParticipant = user?.onboardingExperience?.participating

  const countOfOccurredRecurrentAppointments = pastEhrAppointments.filter(
    (appointment) =>
      appointment.recurring && appointment.lastState.kind === EhrAppointmentStateKind.Occurred,
  ).length
  const userCompletedAllCalls =
    appointmentRecurrence &&
    countOfOccurredRecurrentAppointments >= appointmentRecurrence.numberOfCalls

  useEffect(() => {
    if (userIsParticipant) {
      dispatch({ type: 'nutritionistHub/fetchPastEhrAppointments' })
    }
  }, [dispatch, userIsParticipant])

  return {
    isVisible: appointmentRecurrence && userIsParticipant && !userCompletedAllCalls,
    props: {
      appointmentRecurrenceNumberOfCalls: appointmentRecurrence?.numberOfCalls || 0,
      countOfOccurredRecurrentAppointments,
    },
  }
}
